<template>
  <div class="link">
    <router-link
      :to="{
        name: 'retainer-details',
        query: {
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : data.companyId,
          ID:data.id,
          clientId:clientId
        },
      }"
      :title="$t('text.clickButtons.viewDashboard')"
    >
      <p
        style="
          color: rgb(75, 44, 114);
          margin-top: 20px;
          padding-left: 10px;
          text-align: left !important;
        "
      >
        {{ data.name }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      clientId:""
    };
  },
  mounted() {
    this.clientId = this.data.clientId
  },
  methods: {
    mapToBranch: function (id) {
      this.$eventHub.$emit("_mapGroupToBranch", id);
    },
  },
};
</script>
<style scoped>
.link:hover p{
text-decoration: underline;
}
</style>
